import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { NotificationService } from "../../shared/services/notification.service";
import { Observable, catchError, throwError } from "rxjs";
import { AuthClear, Logout } from "../../shared/store/action/auth.action";
import { environment } from "../../../environments/environment";
import { SingletonStoreService } from "../services/helper/singleton-store.service";
import { APIResponseVM } from "../models/common/common.model";
import { ResponseCodeEnum } from "../enums/common.enum";
import { AuthService } from "../services/api/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router, 
    private store: Store,
    private notificationService: NotificationService,
    private singletonStoreService: SingletonStoreService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {

    const commonHeader = this.store.selectSnapshot(state => state?.common);
    const action = this.singletonStoreService.action.getValue();
    const formCode: any = this.singletonStoreService.formCode.getValue();
    const token =  this.store.selectSnapshot(state => state.auth.token);
    
    if (token) {      
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });  
      if (formCode) {      
        req = req.clone({
          setHeaders: {
            formcode: formCode.toString(),
          },
        });      
      }   
    }
    if (action) {      
      req = req.clone({
        setHeaders: {
          Actiontype: action.toString(),
        },
      });      
    }
    if (commonHeader?.data?.CompanyId) {
      if (!req.url.includes('/get_common_request')) {
        req = req.clone({
          setHeaders: {
            CompanyId: commonHeader?.data?.CompanyId?.toString(),
            Clientkey: environment.clientKey,
            CompanyCode: commonHeader?.data?.CompanyCode?.toString(),
          },
        });        
      }
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.notificationService.notification = false;
          // this.store.dispatch(new AuthClear());
          // this.router.navigate(['/auth/login']);
          this.authService.logout().subscribe({
            next:(res:APIResponseVM<string>)=>{
              if (res.responseCode === ResponseCodeEnum.SUCCESS) {
                this.store.dispatch(new Logout());
                this.router.navigate(['/auth/login']);
              }       
            },
            error:(err: any)=>{console.log(err)}
          });
        }
        return throwError(() => error);
      })
    );
  }
  
}